import { render, staticRenderFns } from "./DeliverableContact.vue?vue&type=template&id=7acef3f2&"
import script from "./DeliverableContact.vue?vue&type=script&lang=js&"
export * from "./DeliverableContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports